module.exports = __webpack_public_path__ + "img/glow.dd3099e2.png";